
<script>
import {Line, mixins} from 'vue-chartjs';
//import zoom from 'chartjs-plugin-zoom';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData'],
  data () {
    return {
      gradient1: null,
      gradient2: null,
      options: {
        scales: {
          /*xAxes: [{
            barPercentage: 0.7,
          }],*/
          yAxes: [{
              gridLines: {
                display: true
              } 
          }]
        },
        legend: {
          display: true,
          position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        /*pan: {
          enabled: true,
          mode: 'xy',
        },
        zoom: {
          enabled: true,
          drag: false,
          mode: 'xy'
        },*/
      }
    }
  },
  watch: {
    chartData: {
      handler: function() {
        /*console.log('watcher line chart here');*/
        //this.resetZoom();
        
      },
      deep: true,
    }
  },
  methods: {
    
  },
  mounted () {
    /*this.gradient1 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    this.gradient1.addColorStop(0, 'rgba(255, 0,0, 0.5)')
    this.gradient1.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    this.gradient1.addColorStop(1, 'rgba(255, 0, 0, 0)');
    
    this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
    this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
    this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');
  
    this.chartData.datasets.map((d) => d.backgroundColor = '#cccccc');*/
    
    //this.addPlugin(zoom);
    this.renderChart(this.chartData, this.options);
    //setTimeout(() => {this.renderChart(this.chartData, this.options), 500}); // we do need this because of the width/height of container

  }
}

</script>
<style>

</style>